<template>
    <div class="orgDetail">
        <div class="left-box">
            <LeftPage :active="7"/>
        </div>
        <div class="right-box flex flex-direction">
            <div class="table-box flex-sub">
                <div class="title">
                    <div class="icon-box">
                        <i class="iconfont icon-yiyishensu"></i>
                    </div>
                    <b>异议申诉管理</b>
                </div>
                <div class="search-flex">
                    <div class="search-box">
                        <el-form ref="form" :model="search" class="flex" label-width="80px">
                            <el-form-item label="关键词">
                                <el-input v-model="search.keyword" placeholder="请输入关键词"></el-input>
                            </el-form-item>
                            <el-form-item label="状态">
                                <el-select v-model="search.status" clearable placeholder="请选择状态">
                                    <el-option
                                        v-for="item in objectionAppealStatusOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                        <div class="search-btn" @click="refreshList">
                            <i class="iconfont icon-sousuo"></i>搜索
                        </div>
                    </div>

                </div>
                <div class="list ">
                    <el-table
                        :cell-style="textCenter"
                        :data="tableData"
                        :header-cell-style="centerbgc"
                        v-loading="loading"
                        border
                        style="width: 100%">
                        <el-table-column
                            label="序号"
                            type="index"
                            width="80">
                        </el-table-column>
                        <el-table-column
                            label="机构名称"
                            prop="org_name"
                            width="">
                        </el-table-column>
                        <el-table-column
                            label="姓名"
                            prop="name"
                            width="130">
                        </el-table-column>
                        <el-table-column
                            label="联系方式"
                            prop="phone"
                            width="130">
                        </el-table-column>
                        <el-table-column
                            label="申诉内容"
                            prop="content">
                        </el-table-column>
                        <el-table-column
                            label="材料附件"
                            prop="files"
                            width="130">
                            <template slot-scope="scope">
                                <el-link :href="scope.row.files" v-if="scope.row.files" target="_blank" type="primary">下载</el-link>
                              <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="添加时间"
                            prop="create_time"
                            width="150">
                        </el-table-column>
                        <el-table-column
                            label="状态"
                            prop="status"
                            width="130">
                            <template slot-scope="scope">
                                {{ scope.row.status | status }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="是否向主管单位投诉"
                            prop="org_name"
                            width="is_up">
                            <template slot-scope="scope">
                                {{ scope.row.is_up === 1 ? '是' : '否' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="180">
                            <template slot-scope="scope" class="flex">
                                <div class="flex align-center justify-center" v-if="scope.row.status === 0">
                                    <edit-reason :params="scope.row"  @reason="submitReason">
                                        <el-link  type="danger">拒绝受理</el-link>
                                    </edit-reason>
<!--                                    <el-link type="danger" @click="submitAudit(2, scope.row)"></el-link>-->
                                    <el-link class="margin-left-sm" type="success" @click="submitAudit(1, scope.row)">
                                        受理
                                    </el-link>
                                </div>
                                <el-link v-else-if="scope.row.status === 1" type="primary" @click="upFileItem(scope.row)">
                                    受理结果上传
                                </el-link>
                                 <el-link type="primary" @click="lookItem(scope.row)" v-else>查看</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="page-box">
                    <el-pagination
                        :current-page.sync="search.page"
                        :page-size="search.limit"
                        :total="search.total"
                        background
                        class="page-all margin-top self-end"
                        layout="prev, pager, next"
                        @current-change="list">
                    </el-pagination>
                </div>
            </div>
        </div>
        <up-file-objection-appeal-dialog :dialog-visible="upFileObjectionAppealDialog" :id="cur_id" @handleClose="handleClose"></up-file-objection-appeal-dialog>
    </div>
</template>
<script>
import {objectionAppealStatusOptions} from "@/utils/const";
import {confirm, findByType} from "@/utils/utils";
import {getObjectionAppealList, setObjectionAppealState} from "@/api/admin";
import LeftPage from "@/views/admin/pages/info/common/leftPage";
import UpFileObjectionAppealDialog from "@/views/admin/pages/info/objectionAppeal/common/upFileObjectionAppealDialog";
import EditReason from "@/components/EditReasonDialog";

export default {
    name: "objectionAppeal",
    data() {
        return {
            objectionAppealStatusOptions: objectionAppealStatusOptions,
            search: {
                keyword: '',
                status: '',
                page: 1,
                limit: 10,
                total: 0,
            },
            tableData: [],

            loading: false,

            cur_id: '',
            upFileObjectionAppealDialog:false
        }
    },
    components: {EditReason, UpFileObjectionAppealDialog, LeftPage},
    computed: {
        textCenter() {
            return {
                textAlign: 'center'
            }
        },
        centerbgc() {
            return {
                textAlign: 'center',
                background: '#f7f7f7'
            }
        }
    },
    created() {
        this.$emit("setActive", {
            headActive: 5
        })
        this.list()
    },
    methods: {
        async list() {
            this.loading = true
            let _data = await getObjectionAppealList(
                this.search.keyword,
                this.search.status,
                this.search.page,
                this.search.limit
            );
            this.loading = false
            if (_data.status == 200) {
                this.tableData = _data.data.data
                this.search.total = _data.data.total
            } else {
                this.$message.error(_data.msg)
            }
        },
        refreshList() {
            this.search.page = 1
            this.list()
        },
        submitAudit(type, item) {
            confirm('提示', `确定${type === 1 ? '通过' : '拒绝'}该异议申诉吗?`, () => {
                this.auditInfo(type,item.id);
            })
        },
        submitReason(data) {
            this.auditInfo(2,data.id,'',data.reason,data.ref)
        },
        async auditInfo(type,id,file = '',reason = '',ref = '') {
            let _data = await setObjectionAppealState(id,type,file,reason)
            if (_data.status == 200) {
                this.$message.success('操作成功')
                this.list()
                ref && ref.cancel()
                this.upFileObjectionAppealDialog = false
            } else {
                this.$message.error(_data.msg)
            }
        },
        lookItem(item){
          if (item.status === 2){
              confirm('拒绝原因',item.remark)
          } else{
              window.open(item.jieguo_file)
          }
        },
        upFileItem(item) {
            this.cur_id= item && item.id || ''
            this.upFileObjectionAppealDialog = true
        },
        handleClose(data) {
            if (data){
                this.auditInfo(3,data.id,data.file);
            }else {
                this.upFileObjectionAppealDialog = false
            }
        }
    },
    watch: {},
    filters: {
        status(val) {
            return findByType(objectionAppealStatusOptions, val)
        }
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #f61919;
}

.orgDetail {
    width: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;
    display: flex;
    justify-content: flex-start;

    .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 25px;
        border-bottom: 1px solid #e3e7f0;

        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 10px;
        }

        .icon-box {
            width: 30px;
            height: 30px;
            background-image: linear-gradient(-30deg,
                #3579fb 0%,
                #44a3ff 100%);
            box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
            border-radius: 10px;
            text-align: center;
            line-height: 30px;

            i {
                font-size: 20px;
                color: #ffffff;
            }
        }
    }
}

.right-box {
    flex: 1;
    margin-left: 25px;
    width: 100%;
      min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;

    .table-box {
        width: 100%;
        background-image: linear-gradient(0deg,
            #ffffff 84%,
            #edf6ff 100%);
        padding: 30px 20px 0;
        border-radius: 10px;
        min-height: 500px;

        .tab {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: solid 2px #e3e7f0;

            span {
                width: max-content;
                margin-left: 45px;
                height: 60px;
                line-height: 60px;
                font-size: 18px;
                color: #63686e;
                margin-right: 20px;
                cursor: pointer;

                &.active {
                    color: #2791ff;
                    font-weight: bold;
                    border-radius: 2px;
                    border-bottom: solid 4px #2791ff;
                }
            }
        }


        .list {
            width: 100%;

            .btn {
                width: 60px;
                height: 26px;
                border-radius: 4px;
                font-size: 14px;
                text-align: center;
                line-height: 26px;
                margin: 0 auto;

                &.gray {
                    color: #8a8a8a;
                    background-color: #f2f2f2;
                }

                &.yellow {
                    color: #fad471;
                    background-color: #fffbdd;
                }

                &.orange {
                    color: #f58739;
                    background-color: #ffeedd;
                }

                &.red {
                    color: #f8001a;
                    background-color: #ffdddd;
                }
            }
        }

        .search-flex {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 20px 0;

            .shensu {
                min-width: 113px;
                height: 37px;
                background-image: linear-gradient(0deg,
                    #f59a23 0%,
                    #feb555 100%);
                border-radius: 4px;
                padding: 0 20px;
                text-align: center;
                line-height: 37px;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;

                i {
                    font-size: 20px;
                    margin-right: 5px;
                    color: #ffffff;
                }
            }

            .search-box {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .search-btn {
                    width: 112px;
                    height: 36px;
                    background-image: linear-gradient(0deg,
                        #2791ff 0%,
                        #81b6ff 100%);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-size: 16px;
                    color: #ffffff;
                    margin-left: 15px;
                    cursor: pointer;

                    i {
                        font-size: 20px;
                        margin-right: 5px;
                        color: #ffffff;
                    }

                    &.reset {
                        background-image: none;
                        background-color: #ffffff;
                        border-radius: 4px;
                        border: solid 1px #cccccc;
                        line-height: 34px;
                        color: #333333;

                        i {
                            color: #999999;
                        }
                    }
                }
            }

        }
    }
}
</style>


